// extracted by mini-css-extract-plugin
export default {"progress":"yq35D","progressText":"wy33c"};